import axios from "axios";
import { Dispatch } from "react";
import { logoutUser } from "Redux/checkLoginSlice";
import { baseUrl, tenant } from "Shared/BaseUrl";
import { TOKEN_KEY } from "Shared/Tokens";
import { createNotification } from 'Utils/CreateNotification';

export class EBSRequest {

    static get(url: string) {
        return axios.get(url, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem(TOKEN_KEY),
                'X-Tenant': tenant,
            }
        })
    }


    static post = async (url: string, data: FormData | null, dispatch: Dispatch<any>, showToast: boolean = true) => {
        // console.log('tenant is ', tenant);
        const isFormData = data instanceof FormData;
        console.log('tenant is ', tenant)
        var response = await axios({
            method: 'POST',
            url: baseUrl + url,
            data: data ?? {},
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem(TOKEN_KEY),
                'X-Tenant': tenant,
                'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
                'Accept': 'application/json',
            },
        })
            .then((res) => {
                // Treating 200 and 202 as successful
                if (res.status === 200 || res.status === 202) {
                    {
                        showToast &&
                            createNotification('success', res.data.message);
                    }
                    return { data: res.data, err: null, status: res.status };
                } else {
                    return { data: null, err: res.data?.message || 'Unknown error', status: res.status };
                }
            })
            .catch((e) => {
                var data = e.response.data;
                if (e.response.status === 401) {
                    dispatch(logoutUser());
                } if (e.response.status === 400 && showToast) {
                    createNotification('error', data.message);
                } else {
                    {
                        showToast &&
                            createNotification('error', e.message);
                    }
                }
                return { data: data, err: data.message, status: e.response.status };
            })
        return response;
    }

    static put = async (url: string, data: FormData | null, dispatch: Dispatch<any>) => {
        var response = await axios({
            method: 'PUT',
            url: baseUrl + url,
            data: data,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem(TOKEN_KEY),
                'X-Tenant': tenant,
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            },
        })
            .then((res) => {
                if (res.status === 200) {
                    createNotification('success', res.data.message);
                    return { data: res.data, err: null, status: res.status };
                } else {
                    return { data: null, err: res.data.message, status: res.status };
                }
            })
            .catch((e) => {
                var data = e.response.data;
                if (e.response.status === 401) {
                    dispatch(logoutUser());
                } if (e.response.status === 400) {
                    createNotification('error', data.message);
                } else {
                    createNotification('error', e.message);
                }
                return { data: data, err: data.message, status: e.response.status };
            })
        return response;
    }

    static delete = async (url: string, dispatch: Dispatch<any>) => {
        var response = await axios({
            method: 'DELETE',
            url: baseUrl + url,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem(TOKEN_KEY),
                'X-Tenant': tenant,
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
            },
        })
            .then((res) => {
                if (res.status === 200) {
                    createNotification('success', res.data.message);
                    return { data: res.data, err: null, status: res.status };
                } else {
                    return { data: null, err: res.data.message, status: res.status };
                }
            })
            .catch((e) => {
                var data = e.response.data;
                if (e.response.status === 401) {
                    dispatch(logoutUser());
                }
                createNotification('error', e.message);
                return { data: data, err: data.message, status: e.response.status };
            })
        return response;
    }


    // switch case class for status codes
    static getStatusCode(statusCode: number) {
        switch (statusCode) {
            case 200:
                return "OK";
            case 201:
                return "Created";
            case 202:
                return "Accepted";
            case 204:
                return "No Content";
            case 400:
                return "Bad Request";
            case 401:
                return "Unauthorized";
            case 403:
                return "Forbidden";
            case 404:
                return "Not Found";
            case 500:
                return "Internal Server Error";
            default:
                return "Unknown";
        }
    }
}